import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios";
import { apiRoot } from "..";
import { Spinner } from "react-bootstrap";

const DocumentAdd = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const fetchDocumentGroupsQuery = useQuery(['fetchDocumentGroups'], async () => {
    const {data} = await axios.get(apiRoot + '/document-groups');
    return data;
  }, {
    onError: (err) => {
      console.log('fetchDocumentGroups error: ' + err) // TODO
    }
  });

  const [inputs, setInputs] = useState({});
  const [errorMessage, setErrorMessage] = useState(null);

  const addDocumentMutation = useMutation((formData) => {
    return axios.post(apiRoot  + '/documents', formData, {
      headers: {
        "Content-Type": "multipart/form-data"
      },
    });
  },
  {
    onSuccess: () => {
      queryClient.invalidateQueries(['fetchDocuments']);
      navigate("/dokumenty");
    },
    onError: (error) => {
      setErrorMessage(error.message); // TODO json -> errorCode -> hlaska
      window.scrollTo(0, 0);
    }
  });

  const handleChange = (event) => {
    if (!addDocumentMutation.isLoading) {
      const name = event.target.name;
      const value = (name === 'fileToUpload' ? event.target.files[0] : event.target.value);
      setInputs(values => ({...values, [name]: value}))
    }
  }

  const handleSubmit = (event) => {
    event.preventDefault();
    setErrorMessage(null);

    if (!inputs.fileToUpload || !inputs.name || !inputs.description || !inputs.documentGroup) { // TODO trim
      setErrorMessage('Některé povinné položky nejsou vyplněné.');
      window.scrollTo(0, 0);
      // TODO zvyrazneni nevyplnenych vstupnich poli
      return;
    }

    const formData = new FormData();
    for (let name in inputs) {
      formData.append(name, inputs[name]);
    }

    addDocumentMutation.mutate(formData);
  }

  // TODO da se lepe?
  if (fetchDocumentGroupsQuery.data && fetchDocumentGroupsQuery.data[0] && !inputs.documentGroup) {
    setInputs(values => ({...values, documentGroup: fetchDocumentGroupsQuery.data[0].id}))
  }

  return (
    <>
<div>
<span className="align-middle">
<i className="fa fa-file-text-o fa-3x fa-in-header align-middle" aria-hidden="true"></i>
<h2 className="d-inline-block align-middle">Přidat dokument</h2>
</span>
</div>

{fetchDocumentGroupsQuery.isLoading &&
<div className="text-center">
  <Spinner animation="border" variant="secondary" role="status">
    <span className="visually-hidden">Nahrávám...</span>
  </Spinner>
</div>
}
{fetchDocumentGroupsQuery.isError &&
  <div className="alert alert-danger" role="alert">Chyba při nahrávání skupin dokumentů.</div>
}
{fetchDocumentGroupsQuery.data && 
<form onSubmit={handleSubmit}>

<table>
<tbody>
<tr>
<td>{errorMessage && <div className="alert alert-danger" role="alert">{errorMessage}</div>}</td>
</tr><tr>
<td><strong>Soubor:</strong></td>
</tr><tr>
<td><input type="file" className="form-control" name="fileToUpload" size="70" onChange={handleChange} /></td>
</tr><tr>
<td><strong>Název:</strong></td>
</tr><tr>
<td><input type="text" className="form-control" name="name" size="70" value={inputs.name || ""} onChange={handleChange} /></td>
</tr><tr>
<td><strong>Popisek:</strong> <em>(umožňuje formátování pomocí <a href="http://www.edgering.org/markdown/" target="_blank" rel="noreferrer">Markdown značek</a>)</em></td>
</tr><tr>
<td><textarea className="form-control" name="description" cols="80" rows="7" value={inputs.description || ""} onChange={handleChange} /></td>
</tr><tr>
<td><strong>Skupina:</strong></td>
</tr><tr>
<td>
<select className="form-select" name="documentGroup" value={inputs.documentGroup || ""} onChange={handleChange}>
{fetchDocumentGroupsQuery.data.map(documentGroup => (
  <option key= {documentGroup.id} value={documentGroup.id}>{documentGroup.name}</option>
))}

</select>
</td>
</tr><tr>
<td><button type="submit" className="btn btn-success" disabled={addDocumentMutation.isLoading}><i className="fa fa-plus" aria-hidden="true"></i> Přidat dokument</button>
{addDocumentMutation.isLoading ? (<> <Spinner as="span" animation="border" size="sm" /></>) : (<></>)}</td>
</tr>
</tbody>
</table>

</form>
}
    </>
  );
};

export default DocumentAdd;